import React, { useCallback } from 'react'
import { createApiCall } from 'services'
import { storage, decodeJwtPayload } from 'utils'

interface ImpersonatingAs {
  companyId: string
  companyName?: string
  originalAdminId: string
  tenantUserId: string
  jti: string
}

interface ImpersonationBannerProps {
  onExit: () => void
}

export const ImpersonationBanner: React.FC<ImpersonationBannerProps> = ({ onExit }) => {
  // All hooks BEFORE any early return — a conditional hook makes call order depend on
  // the render path and unmounts the app to a blank screen (Rules of Hooks).
  const handleExit = useCallback(async () => {
    try {
      await createApiCall({ method: 'POST', url: '/impersonation/exit' })
    } catch (err) {
      console.error('Failed to call exit endpoint', err)
    } finally {
      storage.removeItem('accessToken')
      storage.removeItem('refreshToken')
      storage.removeItem('scanToken')
      onExit()
    }
  }, [onExit])

  const token = storage.getItem('accessToken')
  const impersonatingAs: ImpersonatingAs | null =
    (token ? decodeJwtPayload(token) : null)?.impersonatingAs ?? null

  if (!impersonatingAs) return null

  const companyLabel = impersonatingAs.companyName || impersonatingAs.companyId

  return (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        zIndex: 9999,
        backgroundColor: '#7c3aed',
        color: '#fff',
        padding: '10px 16px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '16px',
        fontSize: '14px',
        fontFamily: 'inherit',
        boxShadow: '0 1px 8px rgba(0,0,0,0.18)',
      }}
    >
      <span>
        You're viewing <strong>{companyLabel}</strong>'s space as Vera staff.
      </span>
      <button
        onClick={handleExit}
        style={{
          background: '#fff',
          border: 'none',
          color: '#7c3aed',
          borderRadius: '6px',
          padding: '5px 14px',
          cursor: 'pointer',
          fontSize: '14px',
          fontWeight: 600,
          whiteSpace: 'nowrap',
        }}
      >
        Return to Internal
      </button>
    </div>
  )
}
